(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kw-holiday-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }
    function tick() {
      var boxes = document.querySelectorAll('[data-kw-cutoff]');
      if (!boxes.length) return;
      var now = Math.floor(Date.now() / 1000);
      boxes.forEach(function (box) {
        var left = parseInt(box.getAttribute('data-kw-cutoff'), 10) - now;
        if (left <= 0) {
          box.remove();
          return;
        }
        var d = Math.floor(left / 86400);
        var h = Math.floor((left % 86400) / 3600);
        var m = Math.floor((left % 3600) / 60);
        var s = left % 60;
        var text = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
        var timer = box.querySelector('[data-kw-timer]');
        var wrap = box.querySelector('[data-kw-timer-wrap]');
        if (timer && timer.textContent !== text) timer.textContent = text;
        if (wrap && wrap.hidden) wrap.hidden = false;
      });
    }
    if (window.__kwXmasTimer) return;
    window.__kwXmasTimer = setInterval(tick, 1000);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tick);
    } else {
      tick();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
